export enum ScreenerIntentComparisons {
  EQ = 'EQ',
  GT = 'GT',
  GE = 'GE',
  LT = 'LT',
  LE = 'LE',
  BTW = 'BTW',
  ONE_OF_THEM = 'ONE_OF_THEM',
}
